import { render } from "./TheCategoryPanel.vue?vue&type=template&id=6e7140d4&scoped=true&ts=true"
import script from "./TheCategoryPanel.vue?vue&type=script&lang=ts"
export * from "./TheCategoryPanel.vue?vue&type=script&lang=ts"

import "./TheCategoryPanel.vue?vue&type=style&index=0&id=6e7140d4&scoped=true&lang=css"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7140d4"]])

export default __exports__